<div v-if="is_open" class="settings-modal-backdrop" @click.self="$emit('close')">
    <div class="settings-modal-card glass-card rounded-4 settings-user-modal-card p-0">
        <div class="d-flex justify-content-between align-items-start gap-3 p-3 border-bottom border-white border-opacity-10">
            <div>
                <h5 class="text-white fw-bold mb-1">Edit User</h5>
                <p class="text-white-50 text-xs mb-0">Update user details and account access.</p>
            </div>

            <button type="button" class="btn btn-sm btn-outline-light rounded-circle settings-modal-close text-xs" @click="$emit('close')" aria-label="Close">
                <i class="bi bi-x-lg"></i>
            </button>
        </div>

        <form class="p-3" @submit.prevent="submit_form">
            <div v-if="form_error" class="alert alert-danger border-0 rounded-4" role="alert">
                {{ form_error }}
            </div>

            <div v-if="is_loading_user" class="d-flex align-items-center gap-3 text-white-50 mb-3">
                <div class="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></div>
                <span class="text-xs">Loading user details...</span>
            </div>

            <div class="row g-3">
                <div class="col-md-6">
                    <label for="settings-edit-user-first-name" class="form-label text-white text-xs fw-semibold">First name</label>
                    <input id="settings-edit-user-first-name" v-model.trim="user_form.first_name" type="text" class="form-control form-control-dark text-xs" :disabled="is_loading_user" required>
                </div>

                <div class="col-md-6">
                    <label for="settings-edit-user-last-name" class="form-label text-white text-xs fw-semibold">Last name</label>
                    <input id="settings-edit-user-last-name" v-model.trim="user_form.last_name" type="text" class="form-control form-control-dark text-xs" :disabled="is_loading_user" required>
                </div>

                <div class="col-md-6">
                    <label for="settings-edit-user-email" class="form-label text-white text-xs fw-semibold">Email</label>
                    <input id="settings-edit-user-email" v-model.trim="user_form.email" type="email" class="form-control form-control-dark text-xs" :disabled="is_loading_user" required>
                </div>

                <div class="col-md-6">
                    <label for="settings-edit-user-phone" class="form-label text-white text-xs fw-semibold">Phone</label>
                    <input id="settings-edit-user-phone" v-model.trim="user_form.phone_number" type="tel" class="form-control form-control-dark text-xs" :disabled="is_loading_user">
                </div>
            </div>

            <div class="d-flex justify-content-end gap-2 flex-wrap mt-4">
                <button type="button" class="btn button-outline btn-outline-light rounded-3 d-flex align-items-center gap-1 settings-button-shape" @click="$emit('close')">
                    Cancel
                </button>

                <button type="submit" class="btn-primary rounded-3 d-flex align-items-center gap-1 settings-button-shape" :disabled="is_saving || is_loading_user">
                    <span v-if="is_saving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span>Save changes</span>
                </button>
            </div>
        </form>
    </div>
</div>
